import { MatAutocompleteModule, MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatOptionModule, MatPaginatorModule, MatProgressBarModule, MatRadioModule, MatSelectModule, MatSidenavModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { MatChipsModule } from '@angular/material/chips';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        MatAutocompleteModule, 
        MatButtonModule, 
        MatCheckboxModule, 
        MatChipsModule,
        MatDatepickerModule, 
        MatDialogModule, 
        MatIconModule, 
        MatInputModule, 
        MatListModule, 
        MatMenuModule, 
        MatNativeDateModule, 
        MatOptionModule, 
        MatPaginatorModule, 
        MatProgressBarModule, 
        MatRadioModule, 
        MatSelectModule, 
        MatSidenavModule, 
        MatSnackBarModule, 
        MatSortModule, 
        MatTableModule, 
        MatTabsModule, 
        MatToolbarModule, 
        MatTooltipModule,
    ],
    exports: [
        MatAutocompleteModule, 
        MatButtonModule, 
        MatCheckboxModule, 
        MatChipsModule,
        MatDatepickerModule, 
        MatDialogModule, 
        MatIconModule, 
        MatInputModule, 
        MatListModule, 
        MatMenuModule, 
        MatNativeDateModule, 
        MatOptionModule, 
        MatPaginatorModule, 
        MatProgressBarModule, 
        MatRadioModule, 
        MatSelectModule, 
        MatSidenavModule, 
        MatSnackBarModule, 
        MatSortModule, 
        MatTableModule, 
        MatTabsModule, 
        MatToolbarModule, 
        MatTooltipModule,
    ]
})
export class AppMaterialModule {}


// WEBPACK FOOTER //
// ./src/app/app.material.module.ts